/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * The specific media type of an MediaBrowser.Model.Providers.ExternalIdInfo.
 * @export
 * @enum {string}
 */
const ExternalIdMediaType = {
    Album: 'Album',
    AlbumArtist: 'AlbumArtist',
    Artist: 'Artist',
    BoxSet: 'BoxSet',
    Episode: 'Episode',
    Movie: 'Movie',
    OtherArtist: 'OtherArtist',
    Person: 'Person',
    ReleaseGroup: 'ReleaseGroup',
    Season: 'Season',
    Series: 'Series',
    Track: 'Track',
    Book: 'Book'
};

export { ExternalIdMediaType };
